(function($) {
	'use strict';
	$.fn.Collection__Share = function() {
		this.each(function() {

			/*
			 * Action: Duplicate Collection
			 */
			var $self = $(this),
				collection_id = $self.data('cid');
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();

				// Get options
				var overlay = $('#collection--share').html();

				// Parse it
				Mustache.parse( overlay );
				var output = Mustache.render( overlay );

				// Close other overlays
				var timeout = 10;
				if( $('#overlay-white').length > 0 ) {

					// Make sure we wait for it to be closed
					timeout = $.Globals.fxSpeed;

					// Close the overlay
					$.Globals.closeOverlay();

				}

				setTimeout( function() {

					// Add it to dom and fade it in
					$.Body.append( output );

					// Async
					setTimeout( function() {

						// Fade it in
						$.Body.addClass('overlay-white-on');

						// Save new $overlay
						var $overlay = $('#overlay-white');

						// Listen for form submit
						$overlay.find('form').off('submit.share-collection').on('submit.share-collection', function(e) {
							e.preventDefault();

							// Sets listeners on $self
							$.Globals.overlayNotify( $self, Front.translations.saving, Front.translations.collection_shared );

							// Share the collection in the DB // <= post request so using ajax_share_collection func
							// $.Globals.ajax_share_collection( collection_id, $('#share-collection-email-addresses').val(), $('#share-collection-additional-note').val(), function( data ) { // <= post request
							const options = {
			          cid: collection_id,
			          email: $('#share-collection-email-addresses').val(),
			          note: $('#share-collection-additional-note').val(),
			          type: 'json',
							};
							$.Globals.ajax_post( 'collection__share', options, function( data ) {

								if( data.success ) {

									// Track in Google
									$.Globals.track_event( 'Collection Shared' );

									// Add to list
									var $list = $('.collection-shared-with');
									if( $list.length > 0 ) {
										$.each( data.emails, function( i, val ) {
											$list.append( '<li>' + val + '</li>');
										});
									}


									// Listen for complete to close overlay then trigger success message
									$self.off('overlay-notify-complete').on('overlay-notify-complete', function() {

										$.Globals.closeOverlay();

									}).trigger('overlay-notify-success');


								} else {

									// Error
									console.warn('There was an error sending the email. Were you trying to send it from a dev server? The following was returned:');
									console.log(data);
									$.Globals.closeOverlay();

								}

							});

						});

						$overlay.find('#submit-share').off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function() {
							$overlay.find('form').trigger('submit.share-collection');
						});

						// Add global close overlay listener
						$.Globals.listenForGlobalCloseOverlay();

					}, 10 );


				}, timeout );

			});


		});
		return this;
	};
}(jQuery));
